import { render, staticRenderFns } from "./SetPaperStepTwoJudge.vue?vue&type=template&id=1ae48fce&scoped=true&"
import script from "./SetPaperStepTwoJudge.vue?vue&type=script&lang=js&"
export * from "./SetPaperStepTwoJudge.vue?vue&type=script&lang=js&"
import style0 from "./SetPaperStepTwoJudge.vue?vue&type=style&index=0&id=1ae48fce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae48fce",
  null
  
)

export default component.exports